import { TruncatedTooltip } from '@common/components/TruncatedTooltip';
import { Badge, Flex, Tooltip } from '@radix-ui/themes';
import { PlayIcon } from '@radix-ui/react-icons';
import { useTranslation } from 'react-i18next';

interface MediaItemLabelProps {
    name: string;
    hasProxy?: boolean;
}

export const MediaItemLabel = ({ name, hasProxy }: MediaItemLabelProps) => {
    const { t } = useTranslation('clipTable');

    return (
        <Flex align={'center'} gap={'3'} width={'100%'}>
            <Flex align={'center'} gap={'2'} flexShrink={'0'}>
                {hasProxy && (
                    <Tooltip content={t('tags.proxyAvailable')}>
                        <Badge size='3' variant='soft' radius='full'>
                            <PlayIcon width='14' height='14' />
                        </Badge>
                    </Tooltip>
                )}
            </Flex>
            <TruncatedTooltip text={name}>{name}</TruncatedTooltip>
        </Flex>
    );
};
